import { normalizeQuantity } from "../../../normalizers/normalizeQuantity";
import { attachQuantityToTree, removeQuantityEverywhere, updateQuantityInTree, upsertQuantity } from "../helper";

export function handleAdminQuantityDefinitionUpdated(state, payload) {
    const { category, parent, quantity_definition } = payload;

    const quantity = normalizeQuantity(payload.quantity_definition)

    // 1. upsert
    const quantitiesById = upsertQuantity(
        state.quantitiesById,
        quantity
    );

    // 2. update existing tree node
    const categoriesById = updateQuantityInTree(
        state.categoriesById,
        category,
        parent,
        quantity
    );

    return {
        ...state,
        quantitiesById,
        categoriesById,
    };
}